import { useAppSelector } from "./store";
import { PhaseType } from "./common/Info";
import config from "./appconf";

import "./ButtonBox.css";

function ButtonBox() {
  const game = useAppSelector((state) => {
    return state.game;
  });
  const players = useAppSelector((state) => {
    return state.players;
  });
  const user = useAppSelector((state) => {
    return state.profile;
  });

  const userIndex = players.findIndex((obj) => obj.id === user.id);
  const player = players[userIndex];
  const isUsersTurn = userIndex === game.currentPlayerIndex;

  const handleRollClick = () => {
    fetch(`${config.baseUrl}/api/v1/rollDice`, {
      method: "POST",
      mode: "cors",
      credentials: "include",
    }).then((res) => {
      console.log(
        `player rolled dice and got a http response of ${res.status}`,
      );
    });
  };

  const handlePassClick = () => {
    fetch(`${config.baseUrl}/api/v1/pass`, {
      method: "POST",
      mode: "cors",
      credentials: "include",
    }).then((res) => {
      console.log(`player passed and got a http response of ${res.status}`);
    });
  };

  let buttons = <span></span>;

  if (game.phase === PhaseType.dice) {
    if (isUsersTurn) {
      buttons = (
        <button
          className="actionButton"
          type="button"
          onClick={handleRollClick}
        >
          Roll Dice
        </button>
      );
    }
  } else if (game.phase === PhaseType.white) {
    if (!player.whiteDicePhaseActionTaken) {
      buttons = (
        <button
          className="actionButton"
          type="button"
          onClick={handlePassClick}
        >
          Pass
        </button>
      );
    }
  } else if (game.phase === PhaseType.color) {
    if (isUsersTurn && player.whiteDicePhaseBoxMarked) {
      buttons = (
        <button
          className="actionButton"
          type="button"
          onClick={handlePassClick}
        >
          Pass
        </button>
      );
    }
  }

  return <div className="buttonBox centerContainer">{buttons}</div>;
}

export default ButtonBox;
